import { motion } from "framer-motion";
import { CheckCircle2, ShieldCheck } from "lucide-react";

const items = [
  "Videoatendimento gravado com histórico e trilha de evidência.",
  "Parecer técnico estruturado com recomendação e CID apurado.",
  "Critérios padronizados para reduzir ruído entre áreas.",
  "Base documental para mitigar conflito e judicialização.",
];

export const LegalSecurity = () => {
  return (
    <section
      id="seguranca"
      data-testid="legal-security-section"
      className="relative py-20 md:py-28 bg-[#F6F8FB] overflow-hidden"
    >
      <div className="blob w-[400px] h-[400px] -top-32 -left-32 bg-[#12DDB5]/20" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative grid lg:grid-cols-5 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-2"
        >
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#12DDB5]/12 text-[#0b9a7c] text-xs font-bold uppercase tracking-[0.16em]">
            <ShieldCheck size={14} strokeWidth={2.2} />
            Segurança jurídica
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-[2.5rem] font-extrabold text-[#1F2937] tracking-[-0.02em] leading-[1.1]">
            Rastreabilidade e{" "}
            <span className="text-gradient-brand">segurança jurídica</span> como
            diferenciais
          </h2>
          <p className="mt-5 text-lg text-[#64748B] leading-relaxed">
            Evidência e consistência para decisões mais defensáveis.
          </p>
        </motion.div>

        <motion.ul
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.1 } },
          }}
          className="lg:col-span-3 space-y-4"
        >
          {items.map((t, idx) => (
            <motion.li
              key={t}
              data-testid={`legal-item-${idx}`}
              variants={{
                hidden: { opacity: 0, y: 20 },
                show: { opacity: 1, y: 0 },
              }}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
              className="flex items-start gap-4 bg-white rounded-2xl border border-[#E5EAF2] p-5 md:p-6 hover:border-[#12DDB5] hover:shadow-[0_12px_32px_rgba(18,221,181,0.12)] transition-all duration-300"
            >
              <span className="shrink-0 w-10 h-10 rounded-xl bg-[#12DDB5]/12 flex items-center justify-center text-[#0b9a7c]">
                <CheckCircle2 size={20} strokeWidth={2} />
              </span>
              <p className="text-[#1F2937] font-medium leading-relaxed pt-1.5">
                {t}
              </p>
            </motion.li>
          ))}
        </motion.ul>
      </div>
    </section>
  );
};
